import { type ComponentType, useEffect, useSyncExternalStore } from 'react';

export type InferredProjectPopupContentProps = {
	cloudId: string;
	projectId: string;
	/** The Rovo Chat viewer, so the popup can offer Add to Projects to suggested contributors only. */
	viewerAccountId?: string;
	/** Omit for For You, which has no associated Chat response. */
	feedbackContext?: {
		entryPoint: 'annotation' | 'for-you';
		assistantResponseId?: string;
		conversationId?: string;
		messageRequestId?: string;
		traceId?: string;
	};
	onClose: () => void;
};

type PopupContent = ComponentType<InferredProjectPopupContentProps>;

// Published Rovo packages cannot depend on the private inferred-project page, so the product that
// can registers the whole popup here and the For You rows open it.
let registered: PopupContent | undefined;
const listeners = new Set<() => void>();

export const registerInferredProjectPopupContent = (content: PopupContent | undefined): void => {
	registered = content;
	listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

const getSnapshot = (): PopupContent | undefined => registered;

export const useInferredProjectPopupContent = (): PopupContent | undefined =>
	useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

// No cleanup: another Chat host mounted on the page keeps using the same registration.
export const useRegisterInferredProjectPopupContent = (content: PopupContent): void => {
	useEffect(() => registerInferredProjectPopupContent(content), [content]);
};
